<template>
    <div class="auction-detail__info-body">
        <div class="auction-detail-bid">
            <ViewAuctionInfoBidsCount
                :auction="auction"
                :opened="showBids"
                @toggle-bids="showBids = !showBids"
            />

            <div class="auction-detail-bid__block">
                <div class="auction-detail-bid__block-label">Текущая ставка</div>

                <div
                    v-if="auction.broadcastInfo?.last_bid"
                    class="auction-detail-bid__block-value"
                >
                    {{ numberFormat(auction.broadcastInfo.last_bid.value) }} ₽
                </div>
                <div v-else class="auction-detail-bid__block-value">-</div>
            </div>
        </div>

        <ViewAuctionBidsList :auction="auction" :showed="showBids" />
    </div>
</template>

<script lang="ts" setup>
    import { PropType, ref } from 'vue';

    import { Auction } from '@/types/auction.type.ts';

    import { numberFormat } from '@/utils/NumberFormatter.ts';

    import ViewAuctionBidsList from '@/views/auctions/ViewAuction/components/ViewAuctionBidsList/ViewAuctionBidsList.vue';
    import ViewAuctionInfoBidsCount from '@/views/auctions/ViewAuction/components/ViewAuctionInfoBidsCount/ViewAuctionInfoBidsCount.vue';

    const { auction } = defineProps({
        auction: {
            type: Object as PropType<Auction>,
            required: true,
        },
    });

    const showBids = ref<boolean>(false);
</script>

<style lang="scss" scoped>
    @use "ViewAuctionInfoInProgress.scss";
</style>
